/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Role } from "./role";

/**
 *
 * @export
 * @interface ProjectRole
 */
export interface ProjectRole {
  /**
   *
   * @type {string}
   * @memberof ProjectRole
   */
  projectId: string;
  /**
   *
   * @type {Role}
   * @memberof ProjectRole
   */
  role: Role;
}
